/**
 * Curated NIAP project palette.
 * Each color family has shades from light (100) to dark (900),
 * with a "main" (500) that works well as a standalone.
 *
 * Use for category badges, chart series, tag colors, etc.
 * NOT for semantic theming (use MUI palette for that).
 */
export const niapColors = {
  navy: {
    100: "#d4dce8",
    200: "#a9b9d1",
    300: "#7e96ba",
    400: "#4e6f9e",
    500: "#12315f",
    600: "#0f2a52",
    700: "#0b2241",
    800: "#081a33",
    900: "#051225",
  },
  glyph: {
    100: "#fefefe",
    200: "#f9f9f9",
    300: "#f8f9fa",
    400: "#f0f0f0",
    500: "#ebebeb",
    600: "#e0e0e0",
    700: "#d5d5d5",
    800: "#c9c9c9",
    900: "#bdbdbd",
  },
  gold: {
    100: "#fef6e0",
    200: "#fdecbc",
    300: "#fbdf91",
    400: "#f9d36b",
    500: "#f8c95a", // was 400
    600: "#d4a94b",
    700: "#a8853b",
    800: "#7c622c",
    900: "#50401c",
  },
  rust: {
    100: "#fae0dd",
    200: "#f2b8b1",
    300: "#e88d83",
    400: "#dc6456",
    500: "#c04433",
    600: "#a13829",
    700: "#822d21",
    800: "#632219",
    900: "#441711",
  },
  forest: {
    100: "#d9f0e3",
    200: "#a8dcc0",
    300: "#72c59a",
    400: "#3dae74",
    500: "#198754",
    600: "#147145",
    700: "#105b38",
    800: "#0c452b",
    900: "#082f1e",
  },
  ink: {
    100: "#999999",
    200: "#717171",
    300: "#666666",
    400: "#495057",
    500: "#343a40",
    600: "#212529",
    700: "#1a1e21",
    800: "#121517",
    900: "#0a0c0e",
  },
} as const;

export const approvedColors = {
  coral: { light: "#f1867fff", dark: "#c84141ff" },
  tangerine: { light: "#f7b662ff", dark: "#c65518ff" },
  lime: { light: "#b4df83ff", dark: "#448340ff" },
  teal: { light: "#aee2d6ff", dark: "#448981ff" },
  azure: { light: "#80cff4ff", dark: "#145d83ff" },
  indigo: { light: "#95a2edff", dark: "#353a7aff" },
  violet: { light: "#a8a1ecff", dark: "#5e398bff" },
  slate: { light: "#90A4AE", dark: "#37474F" },
} as const;

export type NiapColorFamily = keyof typeof niapColors;
export type NiapColorShade = keyof (typeof niapColors)[NiapColorFamily];
